export default "__VITE_ASSET__4377eff8__"